/*istanbul ignore next*/"use strict";

exports.__esModule = true;

exports.default = function () {
  return { /*istanbul ignore next*/
    manipulateOptions: function manipulateOptions(opts, parserOpts) {
      parserOpts.plugins.push("asyncGenerators");
    }
  };
};

/*istanbul ignore next*/module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-plugin-syntax-async-generators/lib/index.js
 ** module id = 497
 ** module chunks = 0
 **/